<template>
    <div class="flex flex-wrap justify-start mb-2 gap-2">
        <div v-for="(event, index) in data" :key="index" class="p-4 bg-white rounded-md border border-gray-300 w-full transition relative">
            <div @click="removeSubscription(index)"
                 class="w-5 h-5 absolute text-xs -right-2 -top-2 rounded-full bg-gray-100 text-gray-700 border border-gray-300 flex items-center justify-center hover:scale-90 transition cursor-pointer hover:bg-gray-300">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-3 w-3" fill="currentColor"
                     viewBox="0 0 384 512">
                    <path d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z" />
                </svg>
            </div>
            <div class="w-full p-2 flex items-end gap-2 flex-wrap md:flex-nowrap">
                <input type="hidden" :id="'eventRepeats['+index+'][id]'" :name="'eventRepeats['+index+'][id]'" :value="event.id ?? null">
                <div class="w-full">
                    <label :for="'repeat-' + index" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                        {{ $t("Repeat") }}
                    </label>
                    <select :id="'repeat-' + index" v-model="event.repeat" :name="'eventRepeats['+index+'][repeat]'"
                            class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary focus:border-primary block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary dark:focus:border-primary">
                        <option value="weekly">{{ $t("Weekly") }}</option>
                        <option value="monthly">{{ $t("Monthly") }}</option>
                    </select>
                </div>

                <div class="w-full">
                    <label :for="'day-' + index" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                        {{ $t("Day") }}
                    </label>
                    <select :id="'day-' + index" v-model="event.day" :name="'eventRepeats['+index+'][day]'"
                            class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary focus:border-primary block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary dark:focus:border-primary">
                        <option v-for="(day, index) in getDayOptions(event.repeat)" :key="day" :value="index + 1">{{ day }}</option>
                    </select>
                </div>

                <div class="w-full">
                    <label :for="'start-' + index" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                        {{ $t("Start Time") }}
                    </label>
                    <input :id="'start-' + index" v-model="event.start" :name="'eventRepeats['+index+'][start]'" type="time"
                           class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary focus:border-primary block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary dark:focus:border-primary">
                </div>

                <div class="w-full">
                    <label :for="'end-' + index" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                        {{ $t("End Time") }}
                    </label>
                    <input :id="'end-' + index" v-model="event.end" :name="'eventRepeats['+index+'][end]'" type="time"
                           class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary focus:border-primary block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary dark:focus:border-primary">
                </div>
            </div>

            <div class="w-full p-2 pt-0">
                <label :for="'description-' + index" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                    {{ $t("Description") }}
                </label>
                <input :id="'description-' + index" v-model="event.description" :name="'eventRepeats['+index+'][description]'" type="text"
                       class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary focus:border-primary block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary dark:focus:border-primary">
            </div>
        </div>
        <div @click="addSubscription"
             class="p-4 bg-white rounded-md border border-gray-300 w-full flex justify-center items-center hover:scale-95 active:scale-90 hover:bg-gray-200 transition cursor-pointer">
            <svg xmlns="http://www.w3.org/2000/svg" class="w-6 h-6 mr-2" fill="currentColor"
                 viewBox="0 0 448 512">
                <path d="M256 80c0-17.7-14.3-32-32-32s-32 14.3-32 32V224H48c-17.7 0-32 14.3-32 32s14.3 32 32 32H192V432c0 17.7 14.3 32 32 32s32-14.3 32-32V288H400c17.7 0 32-14.3 32-32s-14.3-32-32-32H256V80z" />
            </svg>
            {{ $t('Add') }} {{ $t("Event Repeat") }}
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            default: { 'repeat': '', 'day': '', 'start': '', 'end': '', 'description': '' },
            data: [],
        };
    },

    created() {
        this.data = this.parseAndFormatData(JSON.parse(this.$attrs.data));
    },

    methods: {
        addSubscription() {
            this.data.push(_.cloneDeep(this.default));
        },
        removeSubscription(index) {
            this.data.splice(index, 1);
        },
        parseAndFormatData(data) {
            return data.map(event => ({
                ...event,
                start: event.start ?? '',
                end: event.end ?? ''
            }));
        },
        getDayOptions(repeat) {
            if (repeat === 'weekly') {
                return ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
            } else if (repeat === 'monthly') {
                return Array.from({ length: 31 }, (_, i) => i + 1);
            }
            return [];
        },
    }
};
</script>
